const invokeFunc = (funcName, ...rest) => {
    return window.external && window.external[funcName] && window.external[funcName].apply(window.external, rest);
}
const isTest = () => {
    return /^(uat|172)/.test(window.location.host);
}
export function getUserInfoFromPC(value) {
    let userInfo = invokeFunc('getUserInfo') || '{}';
    return JSON.parse(userInfo)
}
export function uploadImg(value,bstype,baseImfor) {
    let uploadImg = invokeFunc('uploadImg',value,bstype,baseImfor) || '{}';
    return JSON.parse(uploadImg)
}
export function getUsername(value) {
    let username = invokeFunc('getUsr') || '{}';
    return JSON.parse(username)
}
export function getError(value) {
    let getErrorMsg = invokeFunc('getErrorMsg',value) || '{}';
    return getErrorMsg
}
export function getApiHostForTest(value) {
    // 在uat和本地测试时可以调用PC端提供的方法对接口请求的地址进行更改
    // 线上环境默认返回undefined
    if(isTest) {
        return invokeFunc('getH5ApiHost');
    }
}
export function printOrderPC(title, orderData, callbackName) {
    return invokeFunc('print', title, orderData, callbackName)
}
export default {
    getUserInfoFromPC,
    getApiHostForTest,
    printOrderPC,
    uploadImg,
    getUsername,
    getError
}


// WEBPACK FOOTER //
// ./src/utils/utilsOnlyForPC.js